import { render, staticRenderFns } from "./wapper.vue?vue&type=template&id=4dbc2206&"
import script from "./wapper.vue?vue&type=script&lang=js&"
export * from "./wapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports